import type { ReactNode } from "react";

// Standard "nothing here yet" presentation. Caller passes an icon (any
// inline SVG) plus the message; an optional action slot can hold a
// primary call-to-action button or link.

export function EmptyState({
  icon,
  title,
  message,
  action,
}: {
  icon?: ReactNode;
  title?: string;
  message: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon" aria-hidden="true">{icon}</div>}
      {title && <h3>{title}</h3>}
      <p className="muted">{message}</p>
      {action && <div className="mt">{action}</div>}
    </div>
  );
}

// ---- Icon set ----
// Stroke-only feather-style icons. They inherit colour via
// stroke="currentColor", so they pick up var(--c-muted) from the
// surrounding `.empty-state-icon` block automatically.

const iconProps = {
  width: 48,
  height: 48,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function BatteryIcon() {
  return (
    <svg {...iconProps}>
      <rect x="2" y="7" width="16" height="10" rx="2" />
      <line x1="20" y1="10" x2="20" y2="14" />
      <line x1="6" y1="10" x2="6" y2="14" />
      <line x1="10" y1="10" x2="10" y2="14" />
    </svg>
  );
}

export function ChartIcon() {
  return (
    <svg {...iconProps}>
      <polyline points="3 17 9 11 13 15 21 7" />
      <polyline points="14 7 21 7 21 14" />
    </svg>
  );
}

export function InboxIcon() {
  return (
    <svg {...iconProps}>
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  );
}
